import React from 'react';
import { withTranslation} from "react-i18next";
import {CardElement, Elements, ElementsConsumer} from '@stripe/react-stripe-js';
import { Grid} from '@material-ui/core';

class StripeButton extends React.Component {

    constructor(props){
        super(props);
    }

  render() {    
    
    const { t } = this.props;
    
    return (
        <Grid> 
            <Elements stripe={this.props.stripePromise}>
                <ElementsConsumer>
                    {({elements, stripe}) => (
                        <form onSubmit={this.props.handleSubmit(elements, stripe)}>
                            <CardElement
                            options={{
                                style: {
                                base: {
                                    fontSize: '16px',
                                    color: '#424770',
                                    '::placeholder': {
                                    color: '#aab7c4',
                                    },
                                },
                                invalid: {
                                    color: '#9e2146',
                                },
                                },
                            }}
                            />
                            <button type="submit" variant="outlined" size="small" color="secondary">
                            {t('buyvotes_paywith_stripe')}
                            </button>
                        </form>
                    )}
                </ElementsConsumer>
            </Elements>
        </Grid>
    );
  }
}

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

export default (withTranslation()(StripeButton));